// src/utils/extrasConfig.js - Dynamic extras pricing configuration
import APIService from '../services/api';

// Fallback pricing (used if API fails)
const FALLBACK_PRICING = {
  childSeat: 5,
  boosterSeat: 5,
  meetGreet: 0,
  extraStop: 10
};

// Dynamic pricing object (populated from API)
let EXTRAS_DATA = [];

// Current pricing (starts with fallback, gets updated from API)
export let EXTRAS_PRICING = { ...FALLBACK_PRICING };

export const EXTRAS_LABELS = {
  childSeat: 'Child seat',
  boosterSeat: 'Booster seat', 
  meetGreet: 'Meet & Greet',
  extraStop: 'Extra stop'
};

// Fetch extras from API and update pricing
const loadExtrasFromAPI = async (currency) => {
  try {
    EXTRAS_DATA = await APIService.getVehicleExtras(currency);
    
    // Update EXTRAS_PRICING with API data
    EXTRAS_DATA.forEach(extra => {
      switch(extra.code) {
        case 'child_seat':
          EXTRAS_PRICING.childSeat = extra.price;
          break;
        case 'booster_seat':
          EXTRAS_PRICING.boosterSeat = extra.price;
          break;
        case 'meet_greet':
          EXTRAS_PRICING.meetGreet = extra.price;
          break;
        case 'wifi':
          EXTRAS_PRICING.extraStop = extra.price; // or add wifi if needed
          break;
      }
    });
    
    console.log('✅ Extras pricing updated from API:', EXTRAS_PRICING);
  } catch (error) {
    console.warn('⚠️ Failed to load extras from API, using fallback pricing:', error);
  }
};

// Load pricing on module import
loadExtrasFromAPI();

// Export function to get extra by code (useful for components)
export const getExtraByCode = (code) => {
  return EXTRAS_DATA.find(extra => extra.code === code);
};

// Export function to manually refresh pricing
export const refreshExtrasPricing = (currency) => loadExtrasFromAPI(currency);